import * as React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
const workshops = [{
  id: 1,
  title: "Get a Precise Valuation of Your Illinois Home",
  description: "Understand your property's true market value using AI-assisted analysis combined with local market expertise.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662596/img/illinois_home_valuation.png",
  link: "/HomePage"
}, {
  id: 2,
  title: "Listing Guidance & Coordination",
  description: "Prepare your Illinois home for sale with structured guidance and coordination from trusted, licensed professionals.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662596/img/listing_coordination_meeting.png",
  link: "/HomePage"
}, {
  id: 3,
  title: "Offer Review & Decision Support",
  description: "Navigate offers with confidence. We help you understand structures, contingencies, and trade-offs before you sign.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662596/img/offer_review_handshake.png",
  link: "/HomePage"
}, {
  id: 4,
  title: "Exit Strategy Planning",
  description: "Plan your out-of-state move with resources, destination research, and connections to trusted real estate partners.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662596/img/exit_strategy_relocation.png",
  link: "/HomePage"
}];
export default function LearnNewSkills() {
  return <section data-section-id="221757" id="core-relocation-services" className="bg-background text-foreground py-20 px-4 md:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="mb-16 text-center">
          <h2 className="font-default text-3xl font-bold tracking-tight md:text-4xl lg:text-5xl text-foreground">
            Core Relocation Services
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-muted-foreground font-sans">
            Our personalized approach ensures a smooth transition from your Illinois home to your next destination.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {workshops.map((workshop, i) => <Card key={workshop.id} data-index={i} className="group flex flex-col overflow-hidden border-border bg-card shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-md">
              <div className="aspect-[4/3] w-full overflow-hidden">
                <img src={workshop.image} alt={workshop.title} className="h-full w-full object-cover rounded-md transition-transform duration-500 group-hover:scale-105" loading="lazy" />
              </div>
              <CardHeader className="flex-none pb-4">
                <CardTitle className="font-default text-xl text-foreground">
                  {workshop.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="flex-grow pb-6">
                <CardDescription className="text-base text-muted-foreground font-sans">
                  {workshop.description}
                </CardDescription>
              </CardContent>
              <CardFooter className="flex-none pt-0">
                <Button asChild variant="default" className="w-full group/btn bg-primary text-primary-foreground hover:bg-primary/90 rounded-sm">
                  <Link to={workshop.link}>
                    Learn more
                    <ArrowRight className="ml-2 size-4 transition-transform group-hover/btn:translate-x-1" />
                  </Link>
                </Button>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}